//TODO: replace the axios import with the local axios file
import * as CONSTANT from "../../constants";
import { syncCartOnLogin } from "../../helpers/cartHelperMethods/syncCart";
import { attachKioskIdToSocialLoginPayloadIfSessionNotExpired, getVisitorId } from "../../helpers/helperMethods";
import { Toast_Func } from "../../helpers/toast.helper";
import {isLogoutAction, resetCart } from "../../redux/slices/cartSlice";
import {resetCheckout } from "../../redux/slices/checkoutSlice";
import { customerBusinessService } from "../../services";
import { brazeLogCustomEventLoyaltyAccountCreated, brazeSetUser } from "../../helpers/brazeHelper";
import TagManager from "react-gtm-module";
import axiosNoInterceptor from "../../services/axiosNoInterceptor";

export async function loginVerification(payload,
  setOtpExpiryTime,
  dispatch,
  setDisplayOtpModal,
  setOtpModalDescription
) {
  try {
    const response = await axiosNoInterceptor.post(`${CONSTANT.CUSTOMER_MICRO_SERVICE}/send-otp`, payload);
    setOtpExpiryTime(response.data.data.expires_at);
    if (localStorage.getItem('enable_recaptcha')) {
      localStorage.removeItem("enable_recaptcha")
    }
    setOtpModalDescription(response.data.data.popup_description);
    Toast_Func({
      status: true,
      message: response?.data?.message
    });
    return true;
  } catch (error) {
    if (error?.response?.data?.enable_recaptcha) {
      dispatch({
        type: "LOGIN_ERROR",
        enable_recaptcha: error?.response?.data?.enable_recaptcha || 0
      });
      localStorage.setItem(
        "enable_recaptcha",
        error?.response?.data?.enable_recaptcha
      )
    }
    if (Boolean(error?.response?.data?.otp_popup)) {
      setOtpExpiryTime(error?.response?.data.data.expires_at);
      setDisplayOtpModal(Boolean(error?.response?.data?.otp_popup));
      setOtpModalDescription(error?.response?.data.data.popup_description);
    }
    Toast_Func({
      status: false,
      message: error?.response?.data?.message || error?.response?.data?.errors?.[0],
    });
    return false;
  }
}

export async function login(dispatch, loginPayload, cartDispatch, updateAccountStatusModal, isCheckoutLogin = false) {
  try {
    dispatch({ type: "REQUEST_LOGIN" });
    //TODO: relace post call later
    const visitorId = getVisitorId()
    const newLoginPayload = attachKioskIdToSocialLoginPayloadIfSessionNotExpired(loginPayload);
    newLoginPayload["visitor_id"] = visitorId
    const response = await axiosNoInterceptor.post(`${CONSTANT.CUSTOMER_MICRO_SERVICE}/login`, newLoginPayload);
    if (response.data.status) {
      dispatch({ type: "LOGIN_SUCCESS", payload: response.data.data });
      localStorage.setItem(
        CONSTANT.CURRENT_USER,
        JSON.stringify({ ...response.data.data, visitor_id: getVisitorId() })
      );
      if (!isCheckoutLogin) syncCartOnLogin(cartDispatch);
    }
  } catch (error) {
    const errorsObject = error?.response?.data?.errors;   
    const errorCode = errorsObject?.code; 
    if (errorCode) {
      const buttonText = CONSTANT.API_CODE_MESSAGES[errorCode]
      updateAccountStatusModal(
        errorsObject.header, 
        errorsObject.text, 
        errorCode,
        buttonText,
        loginPayload.email,
        true,
      );
    } else {
      Toast_Func({
        status: false,
        message: error?.response?.data?.errors?.[0]
          || error?.response?.data?.message
          || error?.response?.data?.error
          || error?.response?.data?.error?.[0]
          || "An error occured. Please try again."
      });
    }
    throw error;
  }

}

export function logout(dispatch, cartDispatch) {
  dispatch({ type: "LOGOUT" });
  cartDispatch(resetCart())
  cartDispatch(resetCheckout())
  localStorage.setItem(
    CONSTANT.CURRENT_USER,
    JSON.stringify({ visitor_id: getVisitorId(), logged_out: true })
  );
  TagManager.dataLayer({ dataLayer: { user_id: null }});
}

export function unauthorizeLogout(dispatch) {
  dispatch(resetCart())
  dispatch(isLogoutAction())
  dispatch(resetCheckout())
  localStorage.setItem(
    CONSTANT.CURRENT_USER,
    JSON.stringify({ visitor_id: getVisitorId() })
  );
  TagManager.dataLayer({ dataLayer: { user_id: null }});
}

export async function socialSignIn(dispatch, loginPayload, signInName, cartDispatch, setLocationCallback, isCheckoutLogin = false, locationId = null, orderType = null){
  try {
    let signInLink = ""
    switch (signInName) {
      case "GOOGLE_SIGNIN":
        signInLink = CONSTANT.GOOGLE_SIGNIN
            break;
      case "FACEBOOK_SIGNIN":
        signInLink = CONSTANT.FACEBOOK_SIGNIN
            break;
      case "APPLE_SIGNIN":
        signInLink= CONSTANT.APPLE_SIGNIN
    }
    dispatch({ type: "REQUEST_LOGIN" });
    //TODO: relace post call later
    const visitorId = getVisitorId()
    const newLoginPayload = attachKioskIdToSocialLoginPayloadIfSessionNotExpired(loginPayload);

    newLoginPayload["visitor_id"] = visitorId
    let response = await axiosNoInterceptor.post(
      `${CONSTANT.CUSTOMER_MICRO_SERVICE}${signInLink}`,
      newLoginPayload
    );

    if (response.data.status) {
      dispatch({ type: "LOGIN_SUCCESS", payload: response.data.data });
      localStorage.setItem(
          CONSTANT.CURRENT_USER,
          JSON.stringify({ ...response.data.data, visitor_id: getVisitorId() })
      );
      if (response.data.data.is_new_user) {
        await brazeSetUser(response.data.data.id);
        console.log('user set')
        brazeLogCustomEventLoyaltyAccountCreated(response.data.data);
      }
      if (!isCheckoutLogin) syncCartOnLogin(cartDispatch, locationId, orderType);
    }
  } catch (error) {
    Toast_Func({ status: false, message: error.response.data.errors[0] });
  }
}

export async function guestLogin(dispatch, cartDispatch, loginPayload) {
  try {
    dispatch({ type: "REQUEST_LOGIN" });
    const response = await customerBusinessService.guestLogin(loginPayload)
    if (response.data.status) {
      dispatch({ type: "LOGIN_SUCCESS", payload: response.data.data });
      brazeSetUser(response?.data?.data?.id)
      localStorage.setItem(
        CONSTANT.CURRENT_USER,
        JSON.stringify(response?.data?.data)
      );
      syncCartOnLogin(cartDispatch);
      return true;
    }
  } catch (error) {
    dispatch({
      type: "LOGIN_ERROR",
      error: error?.response?.data?.data?.errors[0],
    });
    return false;
  }
}